import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

//*MUI
import { Box,  Checkbox  , Divider, FormControlLabel , FormGroup, Tooltip} from '@mui/material';
import ClickAwayListener from "@mui/material/ClickAwayListener";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

//*Redux
import { useDispatch  , useSelector} from 'react-redux';
import action from '../../../Redux Store/actions';

//*files
import cssClasses from './EventSiteVisits.module.css';
import DropDown from '../../../Subcomponents/DropDown';
import SearchBar from '../../../Subcomponents/Search';
import Datagrid from '../../../Subcomponents/Datagrid';
import DateComponent from '../../../Subcomponents/DateComponent';
import Button from '../../../Subcomponents/Button';
import { getAllSiteVisitByEventId, getEventByEventName } from '../../../Services/Event';
import AddSiteVisit from '../../../Modals/AddSiteVisit/AddSiteVisit';
import ViewSiteVisitDetails from '../../../Modals/ViewSiteVisitDetails/ViewSiteVisitDetails';
import SiteVisitIcon from "../../../Assets/Images/Common/NoSiteVisitsFound.svg";
import PlusIcon from '../../Icons/PlusIcon';
import checked from "../../../Assets/Images/Common/checked.svg";
import { debounce, findIndex, orderBy, sortBy } from 'lodash';
import { getAllCpForLaunch } from '../../../Services/ChannelPartner';
import { getUsers } from '../../../Services/Lead';
import { getSpecificLaunch } from '../../../Services/AssignNewToken';
import ProjectIcon from '../../../Assets/Images/Sustenance/ProjectIcon.svg';
import { DataGrid } from '@mui/x-data-grid';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

function SiteVisits() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const { eventID } = useParams();
  const [EventData, setEventData] = useState([]);
  const [AllEventSitesData , setAllEventSitesData] = useState([]);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [ViewSiteEventData , setViewSiteEventData] = useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [pageNumber, setPageNumber] = useState(0);
  const [NoEventsSiteVisitFound , setNoEventsSiteVisitFound] = useState(null);
  const [TotalSiteVisitsCount , setTotalSiteVisitsCount] = useState(0);
  const [EventName , setEventName] = useState("");
  const [search , setSearch] = useState("");
  const [DropDownCpSearch, setDropDownCpSearch] = useState("");
  const [DropdownSalesSearch, setDropDownSalesSearch] = useState("");
  const [DropdownLaunchesSearch, setDropDownLaunchesSearch] = useState("");
 
  //*DropDowns
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState('Latest First');
  const [selectedLaunch, setSelectedLaunch] = useState([]);
  const [selectedCp, setSelectedCp] = useState([]);
  const [showDates, setShowDates] = useState(false);
  const [selectedSales, setSelectedSales] = useState([]);
  const [selectDates, setSelectDates] = useState([
    { label: 'StartDate', value: '' },
    { label: 'EndDate', value: '' },
  ]);
  const [selectedDates, setSelectedDates] = useState(null);

  //*main-DropDown
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [showDropDown, setShowDropDown] = useState(false);
  const [listOfDropDown, setListOfDropDown] = useState([
    { label: 'None', select: true },
    { label: 'Launches', select: false},
    { label: 'CP', select: false },
    { label: 'SM', select: false },
    { label: 'Date', select: false },
  ]);

  //*CP-DropDown
  const [showAllCPDropDown, setShowAllCPDropDown] = useState(false);
  const [AllCPDropDown, setAllCPDropDown] = useState([]);

  //*SM-DropDown
  const [showAllSalesDropDown, setShowAllSalesDropDown] = useState(false);
  const [AllSalesDropDown, setAllSalesDropDown] = useState([]);


  //*launches-DropDown
  const [showAllLaunchesDropDown, setShowAllLaunchesDropDown] = useState(false);
  const [AllLaunchesDropDown, setAllLaunchesDropDown] = useState([]);

  const [helperText, setHelperText] = useState({
    startDate: '',
    endDate: '',
  });

  const [DropdownSearch , setDropDownSearch] = useState("");

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    dispatch(action.activeMenu('eventsitevisits'));
    getAllLaunchesByEventId("")
    getAllCp('');
    getAllUser(''); 
  }, []);

  useEffect(() => {
    console.log('Project-Name', eventID);
    getAllSiteVisitsFromServer(
      0, 
      false, 
      search,
      drpDownSelectedVal,
      selectedLaunch,
      selectedCp,
      selectedSales,
      selectDates,
      selectedDates
    );
    getEventName();
  }, [eventID]);

  const [openViewDetails, setOpenViewDetails] = useState(false);
  const handleViewDetailsOpen = () => setOpenViewDetails(true);
  const handleViewDetailsClose = () => setOpenViewDetails(false);

  function getEventName() {
    getEventByEventName(eventID).then((response) => {
      console.log("Event-Name" , response)
      setEventName(response[0].title)
      setEventData(response)
    }).catch((err) => {
      console.error("Event-Name" , err)
    })
  }

  function getAllSiteVisitsFromServer(
    pageNumber, 
    merge , 
    search  , 
    drpDownSelectedVal,
    selectedLaunch,
    selectedCp , 
    selectedSales , 
    selectDates,
    selectedDates,
    ) {
      getAllSiteVisitByEventId(
        eventID, 
        pageNumber * pageSize,
        pageNumber * pageSize + pageSize - 1 ,
        search,
        drpDownSelectedVal,
        selectedLaunch,
        selectedCp,
        selectedSales,
        selectDates,
        selectedDates,
        ).then((resp) => {
        console.log("SiteVisits" , resp)
        setTotalSiteVisitsCount(resp.count)
        if(resp?.count > 0) {
          setNoEventsSiteVisitFound(true)
        } else {
          setNoEventsSiteVisitFound(false)
        }
        const Data = resp.data.map((el, index) => ({
          ...el,
          id: el.sitevisitid,
          index: index,
          sitevisitdate: el.sitevisitdate,
        }));
        // console.log(resp);
        if (merge) {
          setAllEventSitesData((pre) => [...pre, ...Data]);
        } else {
          setAllEventSitesData([...Data]);
        }
      }).catch((err) => {
        console.error("SiteVisits" , err)
      })
  }

  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber);
    getAllSiteVisitsFromServer(
      passPageNumber,
      true,
      search,
      drpDownSelectedVal,
      selectedLaunch,
      selectedCp,
      selectedSales,
      selectDates,
      selectedDates);
  }

  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    getAllSiteVisitsFromServer(
      pageNumber,
      false,
      e.target.value,
      drpDownSelectedVal,
      selectedLaunch,
      selectedCp,
      selectedSales,
      selectDates,
      selectedDates);
     
  }, 800);


  function clearFilters() {
    setAllEventSitesData([]);
    setSelectedListDropDown([]);
    setListOfDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        select: false,
      }));
      pre[0].select = true;
      return [...pre];
    });
    setAllCPDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });
    setAllSalesDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });

    setSelectedLaunch([]);
    setSelectedDates(null);
    setShowDropDown(false);
    setShowAllCPDropDown(false);
    setShowAllSalesDropDown(false);
    setShowDates(false);
    setSelectedCp([]);
    setSelectedSales([]);
    setDropDownLaunchesSearch('');
    setDropDownCpSearch('')
    setDropDownSalesSearch('');
    setSelectDates((pre) => {
      pre[0].value = '';
      pre[1].value = '';
      return { ...pre };
    });
  }

  function getAllCp(search) {
    getAllCpForLaunch(search)
      .then((resp) => {
        let tempArray = AllCPDropDown;
        tempArray = resp.data.map((el, index) => {
          return {
            label: el.billingName,
            value: false,
            id: el.cpId,
          };
        });
        const sortedCp = orderBy(tempArray, [cp => cp.label.toLowerCase()], ['asc'])
        console.log("sortedCp" , sortedCp)
        setAllCPDropDown(sortedCp);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function getAllUser(search) {
    getUsers(search)
      .then((resp) => {
        let tempArray = AllSalesDropDown;
        tempArray = resp.data.map((el, index) => {
          return {
            label: el.name,
            value: false,
            id: el.userId,
          };
        });
        const sortedArray = orderBy(tempArray, [user => user.label.toLowerCase()], ['asc'])
        setAllSalesDropDown(sortedArray);
      })
      .catch((err) => {
        console.error(err);
      });
  }


  function getAllLaunchesByEventId(search) {
    getSpecificLaunch(eventID , search)
      .then((resp) => {
        console.log('resp' , resp)
        let tempArray = AllLaunchesDropDown;
        tempArray = resp.data.map((el, index) => {
          return {
            label: el.title,
            value: false,
            id: el.launchId,
          };
        });
        console.log("temp-Array" , tempArray)
        const sortedLaunches =  orderBy(tempArray, [launch => launch.label.toLowerCase()], ['asc'])
        setAllLaunchesDropDown(sortedLaunches);
      })
      .catch((err) => {
        console.error(err);
      });
  }
  
  const CpColumns = [
    {
      field: 'Site',
      headerName: 'Leads',
      width: 425,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            {params.row.sitevisiturl ?  <img
              style={{
                width: '4rem',
                height: '4rem',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
              src={
                process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                params.row.sitevisiturl
              }
              alt={''}
            /> : <img src={ProjectIcon} alt={''} />}
           
            <Box>
              <Box className={cssClasses.BoldTitle}>
                {params?.row?.leadname ? params?.row?.leadname : '-'}
              </Box>
              <Box>
                <Box component={'span'} className={cssClasses.semiBoldTitle}>
                  VJ
                  {params?.row?.leaddisplayid
                    ? params?.row?.leaddisplayid?.replace(
                        params?.row?.leaddisplayid?.substring(8, 12),
                        '-' + params?.row?.leaddisplayid?.substring(8, 12)
                      )
                    : '-'}
                </Box>
              </Box>
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'Launches',
      headerName: 'Launches',
      width: 205,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.BoldTitle}>
              {params?.row?.launchname ? params?.row?.launchname : '-'}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'Cp&Fos',
      headerName: 'Channel Partners and their FOS',
      width: 305,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            <Box>
              <Box className={cssClasses.BoldTitle}>
                CP :{' '}
                <Box component={'span'} className={cssClasses.semiBoldTitle}>
                  {' '}
                  {params?.row?.billingname ? params?.row?.billingname : '-'}
                </Box>
              </Box>
              <Box className={cssClasses.BoldTitle}>
                FOS :{' '}
                <Box component={'span'} className={cssClasses.semiBoldTitle}>
                  {params?.row?.fosname ? params?.row?.fosname : '-'}
                </Box>
              </Box>
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'Sales',
      headerName: 'Sales Representative',
      width: 205,
      renderCell: (params) => {
        return (
          <Box className={cssClasses.SubContainer}>
            <Box className={cssClasses.BoldTitle}>
              {params?.row?.username ? params?.row?.username : '-'}
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'VisitDateTime',
      headerName: 'Visit Date & Time ',
      width: 300,
      renderCell: (params) => {
        return (
          <Box>
            {new Date(params.row.sitevisitdate).toDateString()},{' '}
            {new Date(params.row.sitevisitdate).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </Box>
        );
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 180,
      renderCell: (params) => {
        return (
          <Button
            style={{
              color: '#155EEF',
              backgroundColor: '#FFF',
              border: '1px solid #155EEF',
              fontSize: '1.4rem',
              lineHeight: '2rem',
            }}
            btnName={'View Details'}
            padding={'0.5rem 2.5rem'}
            clicked={() => {
              setViewSiteEventData(params.row);
              handleViewDetailsOpen();
            }}
          />
        );
      },
    },
  ];

  const debouncedFetchDropDownSearch1 = debounce((e) => {
    if (showAllLaunchesDropDown) {
      setDropDownLaunchesSearch(e.target.value);
      getAllLaunchesByEventId(e.target.value);
    }
  }, 800);

  const debouncedFetchDropDownSearch2 = debounce((e) => {
    if (showAllCPDropDown) {
      setDropDownCpSearch(e.target.value);
      getAllCp(e.target.value);
    }
  }, 800);

  const debouncedFetchDropDownSearch3 = debounce((e) => {
    if (showAllSalesDropDown) {
      setDropDownSalesSearch(e.target.value);
      getAllUser(e.target.value);
    }
  }, 800);


  function returnRes(value) {
    if (value) {
      getAllSiteVisitsFromServer(
        0, 
        false, 
        search,
        drpDownSelectedVal,
        selectedLaunch,
        selectedCp,
        selectedSales,
        selectDates,
        selectedDates
      );
    }
  }

  return (
    <div className='pageWrapper'>
      <div className={cssClasses.wrapperHeader}>
          <Box>
          <Box className={cssClasses.HeaderTitle}>{EventData[0]?.title}</Box>
          <Tooltip title={<h1>{EventData[0]?.description}</h1>}>
            <Box className={cssClasses.SubTitle} width={'50rem'} overflow={'hidden'} textOverflow={'ellipsis'} whiteSpace={'nowrap'}>
            {EventData[0]?.description}
            </Box>
            </Tooltip> 
          </Box>
          <Box>
          {loggedInUser?.roleId?.accessibleTabs?.Event["View Details"]["Site Visit"]["Add Site Visit"]?.isAccessible && (
            <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            padding={'0.8rem 2.6rem'}
            btnName={'Add Site Visit'}
            btnIcon={<PlusIcon />}
            iconPosition={"left"}
            clicked={handleOpen}
          />
          )}
          </Box> 
      </div>
      <Divider/>
      
        <div className={cssClasses.wrapperFilters}>
          <div className={cssClasses.containerFilterSortBy}>
          <Box className={cssClasses.countTitle} mt={3}>
            {TotalSiteVisitsCount} Site Visits
          </Box>
            <div className={cssClasses.wrapperFilter}>
              <div className={cssClasses.filterTitle}>Filter by</div>
              <div className={cssClasses.wrapperDropDown}>
                <div
                  className={cssClasses.wrapperCustomiseDropDown}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowDropDown(!showDropDown);
                  }}
                >
                  <div className={cssClasses.dropDownLabel}>
                    <span className={cssClasses.dropDownLabelValue}>
                      {selectedListDropDown.join()}
                    </span>
                    {selectedListDropDown.length === 0 && (
                      <span className={cssClasses.dropDownLabelValue}>
                        None
                      </span>
                    )}
                  </div>
                  <span>
                    {' '}
                    <KeyboardArrowDownIcon
                      className={cssClasses.dropDownIcon}
                    />
                  </span>
                </div>
                {showDropDown && (
                  <ClickAwayListener
                    onClickAway={() => {
                      setShowDropDown(false);
                    }}
                  >
                    <div className={cssClasses.containerCustomiseDropDown}>
                      <div className={cssClasses.wrapperSelectAndCheckbox}>
                        <div className={cssClasses.wrapperEachSelect}>
                          {listOfDropDown.map((each, index) => {
                            return (
                              <div
                                className={
                                  each.select
                                    ? cssClasses.selectedVal
                                    : cssClasses.containerEachSelect
                                }
                              >
                                <div
                                  className={cssClasses.eachSelect}
                                  onClick={() => {
                                    setListOfDropDown((pre) => {
                                      pre = pre.map((m) => ({
                                        ...m,
                                        select: false,
                                      }));
                                      // pre[index].select = true;
                                      return [...pre];
                                    });

                                    if (selectedDates != null) {
                                      let indexOfMainList = findIndex(listOfDropDown, ({label}) => label === 'Date');
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }

                                    AllLaunchesDropDown.forEach((el) => {
                                      if (el.value) {
                                        let indexOfMainList = findIndex(listOfDropDown, ({label}) => label === 'Launches');
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                      }
                                    });

                                    AllCPDropDown.forEach((el) => {
                                      if (el.value) {
                                        let indexOfMainList = findIndex(listOfDropDown, ({label}) => label === 'CP');
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                      }
                                    });
                                    AllSalesDropDown.forEach((el) => {
                                      if (el.value) {
                                        let indexOfMainList = findIndex(listOfDropDown, ({label}) => label === 'SM');
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                      }
                                    });
                                    if (each.label === 'None') {
                                      setSelectedListDropDown([]);
                                      setSelectedLaunch([]);
                                      setSelectedCp([]);
                                      setSelectedSales([]);
                                      setSelectedDates(null);
                                      setSelectDates((pre) => {
                                        pre[0].value = '';
                                        pre[1].value = '';
                                        return { ...pre };
                                      });
                                      setListOfDropDown((pre) => {
                                        pre = pre.map((m) => ({
                                          ...m,
                                          select: false,
                                        }));
                                        pre[0].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectDates.startDate === '' ||
                                        selectDates.endDate === ''
                                      ) {
                                        setListOfDropDown((pre) => {
                                          pre[1].select = false;
                                          return [...pre];
                                        });
                                      }
                                      AllLaunchesDropDown.forEach((el) => {
                                        el.value = false;
                                      });
                                      AllCPDropDown.forEach((el) => {
                                        el.value = false;
                                      });
                                      AllSalesDropDown.forEach((el) => {
                                        el.value = false;
                                      });

                                      setShowAllLaunchesDropDown(false);
                                      setShowAllCPDropDown(false);
                                      setShowAllSalesDropDown(false);
                                      setShowDates(false);
                                    } else if (each.label === 'Launches') {
                                      setTimeout(() => {
                                        let _val = document.getElementById("input-with-icon-textfield DropDownLaunchesSearch");
                                        if(_val) {
                                          _val.value = DropdownLaunchesSearch;
                                        }
                                      } , 100)
                                      setShowAllLaunchesDropDown(true)
                                      setShowAllCPDropDown(false);
                                      setShowAllSalesDropDown(false);
                                      setShowDates(false);
                                     } else if (each.label === 'CP') {
                                      setTimeout(() => {
                                        let _val = document.getElementById("input-with-icon-textfield DropDownLeadCpSearch");
                                        if(_val) {
                                          _val.value = DropDownCpSearch;
                                        }
                                      } , 100)
                                      setShowAllLaunchesDropDown(false)
                                        setShowAllCPDropDown(true);
                                        setShowAllSalesDropDown(false);
                                        setShowDates(false);
                                    } else if (each.label === 'SM') {
                                      setTimeout(() => {
                                        let _val = document.getElementById("input-with-icon-textfield DropDownLeadSalesSearch");
                                        if(_val) {
                                          _val.value = DropdownSalesSearch
                                        }
                                      } , 100)
                                      setShowAllLaunchesDropDown(false)
                                      setShowAllCPDropDown(false);
                                      setShowAllSalesDropDown(true);
                                      setShowDates(false);
                                    } else if (each.label === 'Date') {
                                      setShowAllLaunchesDropDown(false)
                                      setShowAllCPDropDown(false);
                                      setShowAllSalesDropDown(false);
                                      setShowDates(true);
                                    }
                                  }}
                                >
                                  {each.label}
                                </div>
                                {each.select && (
                                  <img
                                    src={checked}
                                    alt={'checked'}
                                    style={{ marginRight: '2rem' }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                        <div className={cssClasses.wrapperCheckbox1}>
                        {showAllLaunchesDropDown && (
                          <Box width={"100%"} mb={2}>
                            <SearchBar
                              id={"DropDownLaunchesSearch"}
                              placeholder={"Search"}
                              search={debouncedFetchDropDownSearch1}
                              width="100%"
                            />
                          </Box>
                        )}
                        {showAllCPDropDown && (
                          <Box width={"100%"} mb={2}>
                            <SearchBar
                              id={"DropDownLeadCpSearch"}
                              placeholder={"Search"}
                              search={debouncedFetchDropDownSearch2}
                              width="100%"
                            />
                          </Box>
                        )}

                        {showAllSalesDropDown && (
                          <Box width={"100%"} mb={2}>
                            <SearchBar
                              id={"DropDownLeadSalesSearch"}
                              placeholder={"Search"}
                              search={debouncedFetchDropDownSearch3}
                              width="100%"
                            />
                          </Box>
                        )}
                        <div className={cssClasses.wrapperCheckbox}>
                        {showAllLaunchesDropDown && (
                          <>
                          {AllLaunchesDropDown?.length > 0 ? (
                            AllLaunchesDropDown.map((each, index) => {
                              return (
                                <FormGroup>
                                  <FormControlLabel
                                    sx={[
                                      {
                                        '& .MuiTypography-root': {
                                          fontFamily: 'Inter-Medium !important',
                                          fontStyle: 'normal',
                                          fontWeight: '400',
                                          fontSize: '1.6rem !important',
                                          lineHeight: '2.4rem !important',
                                          color: '#101828',
                                          textTransform: 'capitalize',
                                        },
                                      },
                                    ]}
                                    checked={each.value}
                                    onChange={(e) => {
                                      console.log(e.target.checked);
                                      if (e.target.checked) {
                                        setAllLaunchesDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          selectedLaunch.push(each.id);
                                          return [...pre];
                                        });
                                      } else {
                                        setAllLaunchesDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          return [...pre];
                                        });
                                        setSelectedLaunch(
                                          selectedLaunch.filter(
                                            (id) => id !== each.id
                                          )
                                        );
                                      }
                                      let checkLaunchSelected =
                                      AllLaunchesDropDown.filter(
                                          ({ value }) => value === true
                                        );
                                      if (checkLaunchSelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[1].select = true;
                                          
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Launches'
                                          ) === undefined
                                        ) {
                                          setSelectedListDropDown((pre) => {
                                            return [...pre, 'Launches'];
                                          });
                                        }
                                      } else {
                                        setListOfDropDown((pre) => {
                                          pre[1].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown((pre) => [
                                          ...pre.filter(
                                            (value) => value !== "Launches"
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                              );
                            })
                          ) : (
                            <div className={cssClasses.label}>
                                  No Launches Found
                            </div>
                          )}
                          </>
                        )}
                          {showAllCPDropDown && (
                            <>
                             {AllCPDropDown?.length > 0 ? (
                              AllCPDropDown.map((each, index) => {
                                return (
                                  <FormGroup>
                                    <FormControlLabel
                                      sx={[
                                        {
                                          '& .MuiTypography-root': {
                                            fontFamily: 'Inter-Medium !important',
                                            fontStyle: 'normal',
                                            fontWeight: '400',
                                            fontSize: '1.6rem !important',
                                            lineHeight: '2.4rem !important',
                                            color: '#101828',
                                            textTransform: 'capitalize',
                                          },
                                        },
                                      ]}
                                      checked={each.value}
                                      onChange={(e) => {
                                        console.log(e.target.checked);
                                        if (e.target.checked) {
                                          setAllCPDropDown((pre) => {
                                            pre[index].value = e.target.checked;
                                            selectedCp.push(each.id);
                                            return [...pre];
                                          });
                                        } else {
                                          setAllCPDropDown((pre) => {
                                            pre[index].value = e.target.checked;
                                            return [...pre];
                                          });
                                          setSelectedCp(
                                            selectedCp.filter(
                                              (cp) => cp !== each.id
                                            )
                                          );
                                        }
                                        let checkCpSelected =
                                          AllCPDropDown.filter(
                                            ({ value }) => value === true
                                          );
                                        if (checkCpSelected.length > 0) {
                                          setListOfDropDown((pre) => {
                                            pre[2].select = true;
                                            return [...pre];
                                          });
                                          if (
                                            selectedListDropDown.find(
                                              (value) => value === 'CP'
                                            ) === undefined
                                          ) {
                                            setSelectedListDropDown((pre) => {
                                              return [...pre, 'CP'];
                                            });
                                          }
                                        } else {
                                          setListOfDropDown((pre) => {
                                            pre[2].select = false;
                                            return [...pre];
                                          });
                                          setSelectedListDropDown((pre) => [
                                            ...pre.filter(
                                              (value) => value !== "CP"
                                            ),
                                          ]);
                                        }
                                      }}
                                      control={
                                        <Checkbox
                                          sx={{
                                            '& .MuiSvgIcon-root': {
                                              fontSize: 28,
                                            },
                                          }}
                                        />
                                      }
                                      label={each.label}
                                    />
                                  </FormGroup>
                                );
                              })
                             ) : (
                              <div className={cssClasses.label}>
                                  No CP Found
                                </div>
                             )}
                            </>
                          )}
                          {showAllSalesDropDown && (
                            <>
                            {AllSalesDropDown?.length > 0 ? (
                              AllSalesDropDown.map((each, index) => {
                                return (
                                  <FormGroup>
                                    <FormControlLabel
                                      sx={[
                                        {
                                          '& .MuiTypography-root': {
                                            fontFamily: 'Inter-Medium !important',
                                            fontStyle: 'normal',
                                            fontWeight: '400',
                                            fontSize: '1.6rem !important',
                                            lineHeight: '2.4rem !important',
                                            color: '#101828',
                                          },
                                        },
                                      ]}
                                      checked={each.value}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setAllSalesDropDown((pre) => {
                                            pre[index].value = e.target.checked;
                                            selectedSales.push(each.id);
                                            return [...pre];
                                          });
                                        } else {
                                          setAllSalesDropDown((pre) => {
                                            pre[index].value = e.target.checked;
                                            return [...pre];
                                          });
                                          setSelectedSales(
                                            selectedSales.filter(
                                              (id) => id !== each.id
                                            )
                                          );
                                        }
                                        let checkSalesSelected =
                                          AllSalesDropDown.filter(
                                            ({ value }) => value === true
                                          );
                                        if (checkSalesSelected.length > 0) {
                                          setListOfDropDown((pre) => {
                                            pre[3].select = true;
                                            return [...pre];
                                          });
                                          if (
                                            selectedListDropDown.find(
                                              (value) => value === 'SM'
                                            ) === undefined
                                          ) {
                                            setSelectedListDropDown((pre) => {
                                              console.log('pre: ', pre);
                                              return [...pre, 'SM'];
                                            });
                                          }
                                        } else {
                                          setListOfDropDown((pre) => {
                                            pre[3].select = false;
                                            return [...pre];
                                          });
                                          setSelectedListDropDown((pre) => [
                                            ...pre.filter(
                                              (value) => value !== 'SM'
                                            ),
                                          ]);
                                        }
                                      }}
                                      control={
                                        <Checkbox
                                          sx={{
                                            '& .MuiSvgIcon-root': {
                                              fontSize: 28,
                                            },
                                          }}
                                        />
                                      }
                                      label={each.label}
                                    />
                                  </FormGroup>
                                );
                              }) 
                            ) : (
                              <div className={cssClasses.label}>
                                  No SM User Found
                                </div>
                            )}
                            </>
                          )
                            }
                          {showDates && (
                            <div>
                              <div className={cssClasses.dateDivider}>
                                <div className={cssClasses.label}>
                                  Start Date
                                </div>
                                <DateComponent
                                  value={selectDates[0].value}
                                  minDate={'1 Jan'}
                                  onChangeDate={(value) => {
                                    console.log(value);
                                    setSelectedDates('notNull');
                                    setSelectDates((pre) => {
                                      pre[0].value = value;
                                      return { ...pre };
                                    });
                                    setHelperText((pre) => {
                                      pre.endDate = '';
                                      return { ...pre };
                                    });
                                  }}
                                  helperText={helperText.startDate}
                                ></DateComponent>
                              </div>
                              <div>
                                <div className={cssClasses.label}>End Date</div>
                                <DateComponent
                                  value={selectDates[1].value}
                                  minDate={'1 Jan'}
                                  onChangeDate={(value) => {
                                    setSelectedDates('notNull');
                                    console.log(selectDates[0].value, value);
                                    if (selectDates[0].value === '') {
                                      setHelperText((pre) => {
                                        pre.endDate =
                                          'Please select start date first';
                                        return { ...pre };
                                      });
                                    } else {
                                      if (selectDates[0].value > value) {
                                        setHelperText((pre) => {
                                          pre.endDate =
                                            'Select End Date Greater than start Date';
                                          return { ...pre };
                                        });
                                      } else {
                                        setSelectDates((pre) => {
                                          pre[1].value = value;
                                          return { ...pre };
                                        });
                                        setHelperText((pre) => {
                                          pre.endDate = '';
                                          return { ...pre };
                                        });
                                        setListOfDropDown((pre) => {
                                          pre[4].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Date'
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push('Date');
                                        }
                                      }
                                    }
                                  }}
                                  helperText={helperText.endDate}
                                ></DateComponent>
                              </div>
                            </div>
                          )}
                        </div>
                        </div>
                        
                      </div>
                      <div className={cssClasses.wrapperDropDownButtons}>
                        <div>
                          <Button
                            style={{
                              color: '#344054',
                              backgroundColor: '#ffffff',
                              fontSize: '1.4rem',
                              lineHeight: '2rem',
                            }}
                            padding={'0.8rem'}
                            btnName={'Clear'}
                            clicked={() => {
                              clearFilters();
                              getAllSiteVisitsFromServer(
                                0,
                                false,
                                search,
                                drpDownSelectedVal,
                                [],
                                [],
                                [],
                                selectDates,
                                null
                              );
                            }}
                          />
                        </div>
                        <div>
                          <Button
                            style={{
                              color: '#ffffff',
                              backgroundColor: '#1570EF',
                              fontSize: '1.4rem',
                              lineHeight: '2rem',
                            }}
                            padding={'0.8rem'}
                            btnName={'Apply'}
                            clicked={() => {
                              if (
                                selectDates[1].value === '' &&
                                selectedDates !== null
                              ) {
                                setHelperText((pre) => {
                                  pre.endDate = 'Please Select end Date';
                                  return { ...pre };
                                });
                                setShowDates(true);
                              } else {
                                setHelperText((pre) => {
                                  pre.endDate = '';
                                  return { ...pre };
                                });
                                setShowDates(false);
                              }
                              setShowAllCPDropDown(false);
                              setShowAllSalesDropDown(false);

                              setShowDropDown(false);
                              console.log(helperText);
                              if (
                                helperText.startDate === '' &&
                                helperText.endDate === ''
                              ) {
                                setAllEventSitesData([]);
                                setShowDropDown(false);
                                getAllSiteVisitsFromServer(
                                  0,
                                  false,
                                  search,
                                  drpDownSelectedVal,
                                  selectedLaunch,
                                  selectedCp,
                                  selectedSales,
                                  selectDates,
                                  selectedDates
                                );
                              } else {
                                setShowDropDown(true);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </ClickAwayListener>
                )}
              </div>
            </div>
            <div className={cssClasses.wrapperSortDropDown}>
              <div className={cssClasses.filterTitle}>Sort by</div>
              <div>
                <DropDown
                  list={[
                    'Name Ascending',
                    'Name Descending',
                    'Latest First',
                    'Oldest First',
                  ]}
                  selectedValue={drpDownSelectedVal}
                  onChangeSelect={(_value) => {
                    setDrpDownSelectedVal(_value);
                    setAllEventSitesData([]);
                    getAllSiteVisitsFromServer(
                      0,
                      false,
                      search,
                      _value,
                      selectedLaunch,
                      selectedCp,
                      selectedSales,
                      selectDates,
                      selectedDates
                    );
                  }}
                  placeHolder={'Select'}
                  style={{selectedColor: '#175CD3', background: '#E8F0FE'  }}
                  helperText={''}
                />
              </div>
            </div>
          </div>
          <div className={cssClasses.wrapperSearchBar}>
            <SearchBar
              id={'SiteVisitSearch'}
              value={search}
              placeholder={'Search By LeadName'}
              search={debouncedFetchSearchData}
              width='100%'
            />
          </div>
        </div>
        {NoEventsSiteVisitFound === true &&
        <Box className={cssClasses.GridWrapper}>
          {/* <Datagrid
            rows={AllEventSitesData}
            columns={CpColumns}
            hideFooter={false}
          /> */}
          <DataGrid
            rows={AllEventSitesData}
            columns={CpColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            page={pageMaintain}
            onPageChange={(_page) => {
              console.log(_page);
              setPageMaintain(_page);
              if (pageNumber < _page) {
                getMoreData(_page);
                // setPageNumber(_page);
              }
            }}
            sx={[dataGridStyles]}
          />
        </Box>

    }

      {NoEventsSiteVisitFound === false && 
    <Box>
    <Box width={"100%"} height={"100%"}>
    <Box className={cssClasses.noDataMsg}>
    
    <Box className={cssClasses.emptyIcon}>
   <img src={SiteVisitIcon} alt="No Site Visits Yet" />
    </Box>
    <Box className={cssClasses.emptyTitle}>No Site visit records were found</Box>
    {loggedInUser?.roleId?.accessibleTabs?.Event["View Details"]["Site Visit"]["Add Site Visit"]?.isAccessible && (
      <div className={cssClasses.emptySubTitle}>
      To add a new site visit, click on
      <div className={cssClasses.addLeadBtn}>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Roboto-Regular",
            }}
            padding={'0.8rem 2.6rem'}
            btnName={'Add Site Visit'}
            btnIcon={<PlusIcon />}
            iconPosition={"left"}
            clicked={handleOpen}
          />
      </div>
   </div>
    )}
     </Box>
  </Box>
  </Box>
    }

    {open && (
        <AddSiteVisit
          open={open}
          handleClose={handleClose}
          data={EventData}
          modalType="EventSiteVisit"
          returnRes={returnRes}
        />
      )}

    {openViewDetails && (
        <ViewSiteVisitDetails
        open={openViewDetails}
        handleClose={handleViewDetailsClose}
        data={ViewSiteEventData}
      />
      )}

    </div>
  );
}

export default SiteVisits;
